import { render, staticRenderFns } from "./EmojiMessageTemplate.vue?vue&type=template&id=024efdef&scoped=true&"
import script from "./EmojiMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./EmojiMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmojiMessageTemplate.vue?vue&type=style&index=0&id=024efdef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024efdef",
  null
  
)

export default component.exports